import { FileInterface } from '../../../core';

export class File implements FileInterface {
    private readonly _name?: string = undefined;

    private readonly _content: any = undefined;

    constructor(content: any, name?: string) {
        this._content = content;
        this._name = name;
    }

    get name(): string {
        return this._name;
    }

    get content(): any {
        return this._content;
    }
}
